"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warning = warning;
exports.isIconDefinition = isIconDefinition;
exports.normalizeAttrs = normalizeAttrs;
exports.generate = generate;
exports.getSecondaryColor = getSecondaryColor;
exports.normalizeTwoToneColors = normalizeTwoToneColors;
exports.fetchIcon = exports.useInsertStyles = exports.iconStyles = exports.svgBaseProps = exports.getModifyName = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _colors = require("@ant-design/colors");

var _react = _interopRequireWildcard(require("react"));

var _warning = _interopRequireDefault(require("rc-util/lib/warning"));

var _insertCss = require("insert-css");

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

function warning(valid, message) {
  (0, _warning.default)(valid, "[bedrock-icons-react] ".concat(message));
}

var getModifyName = function getModifyName(value) {
  var modifyName;

  switch (value) {
    case "default":
      modifyName = "";
      break;

    case "large":
      modifyName = "lg";
      break;

    case "middle":
      modifyName = "md";
      break;

    case "small":
      modifyName = "sm";
      break;

    default:
      modifyName = value;
      break;
  }

  return modifyName;
};

exports.getModifyName = getModifyName;

function isIconDefinition(target) {
  return (0, _typeof2.default)(target) === "object" && typeof target.name === "string" && typeof target.theme === "string" && ((0, _typeof2.default)(target.icon) === "object" || typeof target.icon === "function");
}

function normalizeAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(attrs).reduce(function (acc, key) {
    var val = attrs[key];
    var normalizedAttr = (0, _camelCase.default)(key);

    switch (key) {
      case "class":
        acc.className = val;
        delete acc.class;
        break;
      // mask-type特殊处理

      case 'mask-type':
        acc[key] = val;
        break;

      default:
        if (key !== normalizedAttr) {
          delete acc[key];
        }

        acc[normalizedAttr] = val;
    }

    return acc;
  }, {});
}

function generate(node, key, rootProps) {
  if (!rootProps) {
    return /*#__PURE__*/_react.default.createElement(node.tag, (0, _objectSpread2.default)({
      key: key
    }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
      return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
    }));
  }

  return /*#__PURE__*/_react.default.createElement(node.tag, (0, _objectSpread2.default)((0, _objectSpread2.default)({
    key: key
  }, normalizeAttrs(node.attrs)), rootProps), (node.children || []).map(function (child, index) {
    return generate(child, "".concat(key, "-").concat(node.tag, "-").concat(index));
  }));
}

function getSecondaryColor(primaryColor) {
  // choose the second color
  return (0, _colors.generate)(primaryColor)[0];
}

function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }

  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
} // These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4


var svgBaseProps = {
  width: "1em",
  height: "1em",
  fill: "currentColor",
  "aria-hidden": "true",
  focusable: "false"
};
exports.svgBaseProps = svgBaseProps;
var iconStyles = "\n.rock-icon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  vertical-align: -0.13em;\n}\n\n.rock-icon > * {\n  line-height: 1;\n}\n\n.rock-icon svg {\n  display: inline-block;\n}\n\n.rock-icon .rock-icon-icon {\n  display: block;\n}\n\n.rock-icon[tabindex] {\n  cursor: pointer;\n}\n\n.rock-icon-spin::before,\n.rock-icon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
exports.iconStyles = iconStyles;
var cssInjectedFlag = false;

var useInsertStyles = function useInsertStyles() {
  var styleStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iconStyles;
  (0, _react.useEffect)(function () {
    if (!cssInjectedFlag) {
      (0, _insertCss.insertCss)(styleStr, {
        prepend: true
      });
      cssInjectedFlag = true;
    }
  }, []);
};

exports.useInsertStyles = useInsertStyles;
var iconFiles = new Map();

var fetchIcon = function fetchIcon(url) {
  if (iconFiles.has(url)) {
    return iconFiles.get(url);
  }

  var fetcher = fetch(url).then(function (response) {
    if (!response.ok) {
      return {
        ok: response.ok,
        status: response.status,
        svg: null
      };
    }

    return response.text().then(function (responseText) {
      var div = document.createElement("div");
      div.innerHTML = responseText;
      var svg = div.firstElementChild;
      return {
        ok: response.ok,
        status: response.status,
        svg: svg && svg.tagName.toLowerCase() === "svg" ? svg.outerHTML : ""
      };
    });
  });
  iconFiles.set(url, fetcher);
  return fetcher;
};

exports.fetchIcon = fetchIcon;